import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getPrimaryTabUtil } from '../utils/PrimaryTabUtil';
import { addNotification } from '../RealTimeNotificationHandlers/Reducer';
import useOnRealTimeNotification from './useOnRealTimeNotification';
const useRegisterRealTimeNotificationsCallbacks = componentDef => {
  const dispatch = useDispatch();
  const onNewNotification = useCallback(notification => {
    const isPrimary = getPrimaryTabUtil().isPrimary;
    if (isPrimary) {
      dispatch(addNotification({
        notification
      }));
    }
  }, [dispatch]);
  useOnRealTimeNotification(componentDef, onNewNotification);
};
export default useRegisterRealTimeNotificationsCallbacks;